import type { ViewNote } from "building-types/views/viewNotes";

export enum AwningViewNoteType {
  AWNING = "AWNING",
  BRACKET = "BRACKET",
}
export type AwningViewNoteTable = { [key in AwningViewNoteType]: ViewNote };

export enum ExteriorDoorCasingViewNoteType {
  APRON = "APRON",
  HEAD = "HEAD",
  SIDE = "SIDE",
}
export type ExteriorDoorCasingViewNoteTable = { [key in ExteriorDoorCasingViewNoteType]: ViewNote };

export enum ExteriorWindowCasingViewNoteType {
  APRON = "APRON",
  HEAD = "HEAD",
  SIDE = "SIDE",
  STOOL = "STOOL",
}
export type ExteriorWindowCasingViewNoteTable = { [key in ExteriorWindowCasingViewNoteType]: ViewNote };

export enum ShutterViewNoteTypes {
  SHUTTER = "SHUTTER",
}
export type ShutterViewNoteTable = { [key in ShutterViewNoteTypes]: ViewNote };

export enum WindowViewNoteType {
  WINDOW = "WINDOW",
}
export type WindowViewNoteTable = { [key in WindowViewNoteType]: ViewNote };

export enum DoorViewNoteType {
  DOOR = "DOOR",
}

export type DoorViewNoteTable = { [key in DoorViewNoteType]: ViewNote };

enum DoorViewNotes {
  AWNING = AwningViewNoteType.AWNING,
  BRACKET = AwningViewNoteType.BRACKET,
  APRON = ExteriorDoorCasingViewNoteType.APRON,
  HEAD = ExteriorDoorCasingViewNoteType.HEAD,
  SIDE = ExteriorDoorCasingViewNoteType.SIDE,
  DOOR = DoorViewNoteType.DOOR,
}

export type AllDoorViewNoteTable = { [key in DoorViewNotes]: ViewNote };

enum WindowViewNotes {
  AWNING = AwningViewNoteType.AWNING,
  BRACKET = AwningViewNoteType.BRACKET,
  APRON = ExteriorWindowCasingViewNoteType.APRON,
  HEAD = ExteriorWindowCasingViewNoteType.HEAD,
  SIDE = ExteriorWindowCasingViewNoteType.SIDE,
  STOOL = ExteriorWindowCasingViewNoteType.STOOL,
  WINDOW = WindowViewNoteType.WINDOW,
}

export type AllWindowViewNoteTable = { [key in WindowViewNotes]: ViewNote };

export enum PorchViewNoteType {
  COLUMN_BRACKET = "COLUMN_BRACKET",
  PORCH_RAILING = "PORCH_RAILING", // prefixing with PORCH due to a foreseen migration with Railing Catalog being applied to porches.
  PORCH_HEADER = "PORCH_HEADER",
}

export type PorchViewNoteTable = { [key in PorchViewNoteType]: ViewNote };

export enum PorchTrimViewNoteType {
  PORCH_HEADER_TRIM = "PORCH_HEADER_TRIM",
}

export type PorchTrimViewNoteTable = { [key in PorchTrimViewNoteType]: ViewNote };

enum PorchViewNotes {
  COLUMN_BRACKET = PorchViewNoteType.COLUMN_BRACKET,
  PORCH_RAILING = PorchViewNoteType.PORCH_RAILING,
  PORCH_HEADER = PorchViewNoteType.PORCH_HEADER,
  PORCH_HEADER_TRIM = PorchTrimViewNoteType.PORCH_HEADER_TRIM,
}

export type AllPorchViewNoteTable = { [key in PorchViewNotes]: ViewNote };

export const PorchAggregateViewNoteKeys = [...Object.keys(PorchViewNoteType), ...Object.keys(PorchTrimViewNoteType)];

export enum WainscotingViewNoteType {
  WAINSCOTING = "WAINSCOTING",
  CAP = "CAP",
}

export type WainscotingViewNoteTable = { [key in WainscotingViewNoteType]: ViewNote };

export enum RailingViewNoteType {
  RAILING = "RAILING",
}

export type RailingViewNoteTable = { [key in RailingViewNoteType]: ViewNote };

export enum ColumnViewNoteType {
  COLUMN = "COLUMN",
}

export type ColumnViewNoteTable = { [key in ColumnViewNoteType]: ViewNote };

export enum PropViewNoteType {
  PROP = "PROP",
}
export type PropViewNoteTable = { [key in PropViewNoteType]: ViewNote };

export enum ExteriorTrimViewNoteType {
  OUTSIDE_CORNER = "OUTSIDE_CORNER",
  INSIDE_CORNER = "INSIDE_CORNER",
  DORMER_CORNER = "DORMER_CORNER",
  WALL_ROOF_BASEBOARD = "WALL_ROOF_BASEBOARD",
}

enum ExteriorTrimViewNotes {
  OUTSIDE_CORNER = ExteriorTrimViewNoteType.OUTSIDE_CORNER,
  INSIDE_CORNER = ExteriorTrimViewNoteType.INSIDE_CORNER,
  DORMER_CORNER = ExteriorTrimViewNoteType.DORMER_CORNER,
  WALL_ROOF_BASEBOARD = ExteriorTrimViewNoteType.WALL_ROOF_BASEBOARD,
  PORCH_HEADER_TRIM = PorchTrimViewNoteType.PORCH_HEADER_TRIM,
}

export type AllExteriorTrimViewNoteTable = { [key in ExteriorTrimViewNotes]: ViewNote };
